import { User } from "@iventis/domain-model/model/user";
import { styled } from "@iventis/styles";
import { Theme } from "@emotion/react";
import { TreeBrowserComponent } from "@iventis/tree-browser";
import { ProjectUser } from "@iventis/domain-model/model/projectUser";
import React, { useMemo } from "react";
import { BehaviorSubject } from "rxjs";
import { useRefEffectCallback } from "@iventis/utilities";
import { createPeopleNodeTree, PeopleNodeTree } from "./helpers";
import { createUserNodeComponent } from "./tree-nodes";
import { AdminPersonNode, AdminTreeNodeType } from "./types";

export const PeopleSelector: React.FC<{ selectedPeople: User[]; people: User[]; onChange: (user: User, selected: boolean) => void; unavailablePersonIds?: string[] }> = ({
    selectedPeople,
    people,
    onChange,
    unavailablePersonIds,
}) => {
    const nodeTree: PeopleNodeTree = useMemo(() => createPeopleNodeTree(people.map((p) => p as ProjectUser)), [people]);
    const { current } = useRefEffectCallback(
        new BehaviorSubject<User[]>(selectedPeople),
        (subject) => {
            subject.next(selectedPeople);
            return subject;
        },
        [selectedPeople]
    );

    const peopleNodeComponents = useMemo(
        () => ({
            [AdminTreeNodeType.Root]: undefined,
            [AdminTreeNodeType.User]: createUserNodeComponent<AdminPersonNode>({
                enableCheckBox: (id: string) => !unavailablePersonIds?.includes(id),
                showOverflowMenu: false,
                showCheckBoxColumn: true,
                checkValuesSubject: current,
                onCheckChange: (node, checked) => onChange(node.person, checked),
            }),
        }),
        [unavailablePersonIds]
    );
    return (
        <>
            <StyledTreeBrowserComponent
                className="tree-browser"
                node={nodeTree}
                displayRootNode={false}
                components={peopleNodeComponents}
                openNodes={nodeTree.childNodes.map(({ id }) => id)}
            />
        </>
    );
};

const StyledTreeBrowserComponent = styled(TreeBrowserComponent)`
    flex-shrink: 1;
    overflow-y: auto;
    .node-type-User {
        border-bottom: 1px solid ${({ theme }: { theme: Theme }) => theme.otherColors.separatorDark};
    }
`;
